import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/components/Home.vue'
import Login from '@/components/Login.vue'
import store from '../store/index.js'

// below everything is lazy loaded except for Home and Login
const routes = [
    {
        path: '/',
        component: Home,
        name: 'Home',
    },
    {
        path: '/login',
        component: Login,
        name: 'Login',
    },
    {
        path: '/drafts',
        component: () => import('@/components/Drafts.vue'),
        name: 'Drafts',
    },
    {
        path: '/documents',
        component: () => import('@/components/Documents.vue'),
        name: 'Docs',
    },
    {
        path: '/about',
        component: () => import('@/components/About.vue'),
        name: 'About',
    },
    {
        path: '/help',
        component: () => import('@/components/Help.vue'),
        name: 'Help',
    },
    {
        path: '/settings',
        component: () => import('@/components/Settings.vue'),
        name: 'Settings',
    },
    {
        path: '/ways-to-help',
        component: () => import('@/components/WaysToHelp.vue'),
        name: 'WaysToHelp',
    },
    {
        path: '/privacy-policy',
        component: () => import('@/components/PrivacyPolicy.vue'),
        name: 'PrivacyPolicy',
    },
    {
        path: '/contact',
        component: () => import('@/components/Contact.vue'),
        name: 'Contact',
    },
    {
        path: '/account',
        component: () => import('@/components/Account.vue'),
        name: 'Account',
    },
    {
        path: '/subscription',
        component: () => import('@/components/Subscription.vue'),
        name: 'Subscription',
    },
    {
        path: '/draft-detail/:id/:title?',
        component: () => import('@/components/DraftDetail.vue'),
        name: 'DraftDetail',
    },
    {
        path: '/draft-contribute',
        component: () => import('@/components/DraftUpload.vue'),
        name: 'DraftUpload',
    },
    {
        path: '/collection-drafts/:searchType/:bookOrCategoryId?/:collectionTitle?',
        component: () => import('@/components/DraftSearch.vue'),
        name: 'DraftSearch',
    },
    {
        path: '/draft-threading-search',
        component: () => import('@/components/DraftThreadingSearch.vue'),
        name: 'DraftThreadingSearch',
    },
    {
        path: '/draft-tieup-search',
        component: () => import('@/components/DraftTieupSearch.vue'),
        name: 'DraftTieupSearch',
    },
    {
        path: '/document-search/:searchType/:id?/:name?',
        component: () => import('@/components/DocumentSearch.vue'),
        name: 'DocumentSearch',
    },
    {
        path: '/document-detail/:id/:title?',
        component: () => import('@/components/DocumentDetail.vue'),
        name: 'DocumentDetail',
    },
    {
        path: '/acknowledgements',
        component: () => import('@/components/Acknowledgements.vue'),
        name: 'Acknowledgements',
    },
    {
        path: '/weaving-software',
        component: () => import('@/components/WeavingSoftware.vue'),
        name: 'WeavingSoftware',
    },
    {
        path: '/digital-downloads',
        component: () => import('@/components/DigitalDownloads.vue'),
        name: 'DigitalDownloads',
    },
    {
        path: '/treadle-reducer',
        component: () => import('@/components/TreadleReducer.vue'),
        name: 'TreadleReducer',
    },
    {
        path: '/tag-cloud/:searchType',
        component: () => import('@/components/TagCloud.vue'),
        name: 'TagCloud',
    },
    {
        path: '/tags-cleanup',
        component: () => import('@/components/TagsCleanup.vue'),
        name: 'TagsCleanup',
    },
    {
        path: '/myboards',
        component: () => import('@/components/MyBoards.vue'),
        name: 'MyBoards',
    },
    {
        path: '/board-search',
        component: () => import('@/components/BoardSearch.vue'),
        name: 'BoardSearch',
    },
    {
        path: '/updates',
        component: () => import('@/components/Updates.vue'),
        name: 'Updates',
    },
    {
        path: '/draft-editor',
        component: () => import('@/components/DraftEditor.vue'),
        name: 'DraftEditor',
    },
    {
        path: '/draft-arranger',
        component: () => import('@/components/DraftArranger.vue'),
        name: 'DraftArranger',
    },
    {
        path: '/overshot',
        component: () => import('@/components/Overshot.vue'),
        name: 'Overshot',
    },
    {
        path: '/grid-capture',
        component: () => import('@/components/GridCapture.vue'),
        name: 'GridCapture',
    },
    {
        path: '/json-loader',
        component: () => import('@/components/JSONLoader.vue'),
        name: 'JSONLoader',
    },
    {
        path: '/draft-create',
        component: () => import('@/components/DraftCreate.vue'),
        name: 'DraftCreate',
    },
    {
        path: '/draft-editor-instructions',
        component: () => import('@/components/DraftEditorInstructions.vue'),
        name: 'DraftEditorInstructions',
    },
    {
        path: '/draft-editor-introduction',
        component: () => import('@/components/DraftEditorIntroduction.vue'),
        name: 'DraftEditorIntroduction',
    },
    {
        path: '/discover-gradients-promo',
        component: () => import('@/components/DiscoverGradientsPromo.vue'),
        name: 'DiscoverGradientsPromo',
    },
    {
        path: '/gorgeous-gradients-promo',
        component: () => import('@/components/GorgeousGradientsPromo.vue'),
        name: 'GorgeousGradientsPromo',
    },
    {
        path: '/stash-weaving-promo',
        component: () => import('@/components/StashWeavingSuccessPromo.vue'),
        name: 'StashWeavingSuccessPromo',
    },
    {
        path: '/drafting',
        component: () => import('@/components/HandwovenDraftingPromo.vue'),
        name: 'HandwovenDraftingPromo',
    },
    {
        path: '/dull-to-brilliant-promo',
        component: () => import('@/components/DullToBrilliantPromo.vue'),
        name: 'DullToBrilliantPromo',
    },
    {
        path: '/holidays-2023-promo',
        component: () => import('@/components/Holidays2023Promo.vue'),
        name: 'Holidays2023Promo',
    },
    {
        path: '/handwoven-promo',
        component: () => import('@/components/HandwovenPromo.vue'),
        name: 'HandwovenPromo',
    },
    {
        path: '/wggb-promo',
        component: () => import('@/components/GuildPromo.vue'),
        name: 'GuildPromo',
    },
    {
        path: '/jst-promo',
        component: () => import('@/components/JaneStafford2026Promo.vue'),
        name: 'JaneStafford2026Promo',
    },
    {
        path: '/wpm-promo',
        component: () => import('@/components/WPMPromo.vue'),
        name: 'WPMPromo',
    },
    {
        path: '/handwoven-draft-editor-promo',
        component: () => import('@/components/HandwovenDraftEditorPromo.vue'),
        name: 'HandwovenDraftEditorPromo',
    },
    {
        path: '/warp-weave-draft-editor-promo',
        component: () => import('@/components/WarpWeaveDraftEditorPromo.vue'),
        name: 'WarpWeaveDraftEditorPromo',
    },
    {
        path: '/weave-along-promo',
        component: () => import('@/components/WeaveAlongPromo.vue'),
        name: 'WeaveAlongPromo',
    },
    {
        path: '/academy-promo',
        component: () => import('@/components/AcademyPromo2023.vue'),
        name: 'AcademyPromo2023',
    },
    {
        path: '/all-access-promo',
        component: () => import('@/components/AllAccessPromo.vue'),
        name: 'AllAccessPromo',
    },
    {
        path: '/long-thread-promo',
        component: () => import('@/components/LongThreadPromo.vue'),
        name: 'LongThreadPromo',
    },
    {
        path: '/handwoven-2024-drafts-promo',
        component: () => import('@/components/LongThreadDec2023Promo.vue'),
        name: 'LongThreadDec2023Promo',
    },
    {
        path: '/handwoven-2025-drafts-promo',
        component: () => import('@/components/LongThreadDec2023Promo.vue'),
        name: 'LongThreadDec2023Promo',
    },
    {
        path: '/warpweave-promo',
        component: () => import('@/components/WarpWeavePromo.vue'),
        name: 'WarpWeavePromo',
    },
    {
        path: '/warpweave-promo-2021',
        component: () => import('@/components/WarpWeavePromo-2021.vue'),
        name: 'WarpWeavePromo2021',
    },
    {
        path: '/mycs-promo',
        component: () => import('@/components/MYCSPromo.vue'),
        name: 'MYCSPromo',
    },
    {
        path: '/draft-view-test/:id',
        component: () => import('@/components/DraftViewTest.vue'),
        name: 'DraftViewTest',
    },
    {
        path: '/draft-repeats',
        component: () => import('@/components/DraftRepeats.vue'),
        name: 'DraftRepeats',
    },
    {
        path: '/profile',
        component: () => import('@/components/Profile.vue'),
        name: 'Profile',
    },
    {
        path: '/amalgamation',
        component: () => import('@/components/Amalgamation.vue'),
        name: 'Amalgamation',
    },
    {
        path: '/account-reset/:code',
        component: () => import('@/components/PasswordReset.vue'),
        name: 'PasswordReset',
    },
    {
        path: '/video-tutorials',
        component: () => import('@/components/VideoTutorials.vue'),
        name: 'VideoTutorials',
    },
    {
        path: '/mailing-list-signup-confirmation',
        component: () => import('@/components/MailingListSignupConfirmation.vue'),
        name: 'MailingListSignupConfirmation',
    },
    {
        path: '/mailing-list-signup-completed',
        component: () => import('@/components/MailingListSignupCompleted.vue'),
        name: 'MailingListSignupCompleted',
    },
    {
        path: '/video-tutorials',
        component: () => import('@/components/VideoTutorials.vue'),
        name: 'VideoTutorials',
    },
    {
        path: '/videos',
        component: () => import('@/components/VideoTutorials.vue'),
        name: 'Videos',
    },
    // {
    //     path: '/about',
    //     name: 'about',
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    // }
]

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        let delay = to && to.name && to.name === 'DraftSearch' ? 1000 : 500
        return new Promise((resolve, _reject) => {
            setTimeout(() => {
                // console.log('to: ' + JSON.stringify(to) + ', from: ' + JSON.stringify(from) + ' Saved Position: ' + JSON.stringify(savedPosition))
                if (!savedPosition && to && from && to.fullPath !== from.fullPath) {
                    resolve({ left: 0, top: 0, x: 0, y: 0, behavior: 'smooth' })
                } else {
                    if (savedPosition) {
                        resolve({
                            left: savedPosition.left,
                            top: savedPosition.top,
                            x: savedPosition.left,
                            y: savedPosition.top,
                            behavior: 'smooth',
                        })
                    }
                }
            }, delay)
            // note: 1 second delay is so content can full re-render before scroll position is applied, otherwise pages like
            // draft search results with lots of icons might scroll to a position that doesn't yet exist
        })
    },
})

router.beforeEach(async (to, from) => {
    // console.log('in routerInstance.beforeEach, to: ' + JSON.stringify(to.name) + ', from: ' + JSON.stringify(from.name))

    // also see similar code in NavBar to collapse the hamburger for navigation to outside pages (target = _blank)
    try {
        if (!document) {
            // console.log('no document')
        } else {
            let burger = document.getElementById('navbarSupportedContent')
            if (!burger) {
                // console.log('no burger')
            } else {
                burger.classList.remove('show')
            }
            // console.log('burger classes: ' + JSON.stringify(burger.classList))
        }
        // eslint-disable-next-line no-unused-vars
    } catch (_e) {
        // console.log('router.beforeEach error: ' + JSON.stringify(e))
    }

    store.commit('setPreviousRouteName', from.name)
})

export default router
